module.exports = __webpack_public_path__ + "img/1-5.105e6a20.png";